module.exports = "/packs/014-12f280bbe49c2fbde9065210eef33a42.jpg";